import Token from '@/utils/Token';

export default {
    parse(data) {


        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/perfil/${id}${params}`, Token.getHeader());
    },
    permissoes(id) {
        return axios.get(`/api/perfil/permissoes/${id}`, Token.getHeader());
    },
    etapas(id) {
        return axios.get(`/api/perfil/etapas/${id}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/perfil/list${params}`, Token.getHeader());
    },
    option(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/perfil/option${params}`, Token.getHeader());
    },

    create(params) {
        return axios.post(`/api/perfil`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/perfil/${id}`, params, Token.getHeader());
    },
    configuracao(perfil_id,params) {
        return axios.post(`/api/perfil/configuracao/${perfil_id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/perfil/${id}`, Token.getHeader());
    },
}
